export default {
  "items-table-placeholder": "_items-table-placeholder_9gwj7x",
  "item-row": "_item-row_9gwj7x",
  "item-row-labels": "_item-row-labels_9gwj7x",
  "item-row-details": "_item-row-details_9gwj7x",
  "totals": "_totals_9gwj7x",
  "totals-row": "_totals-row_9gwj7x",
  "mb-22": "_mb-22_9gwj7x",
  "ml-4": "_ml-4_9gwj7x",
  "ml-5": "_ml-5_9gwj7x",
  "ml-15": "_ml-15_9gwj7x"
};